// frontend/src/pages/PayrollItems/components/LocationsBody.tsx
// Work locations section body: Active/Inactive radios + one card per location.

import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import type { Location } from "../types";
import { LOCATIONS } from "../data";
import {
  BORDER,
  BG_CARD,
  TEXT_INK,
  TEXT_SECONDARY,
  TEXT_TERTIARY,
  BADGE_PRIMARY,
} from "../styles";
import RadioOpt from "./RadioOpt";

type Segment = "active" | "inactive";

interface LocationsBodyProps {
  /** Called when a card is clicked. Parent decides where to navigate. */
  onCardClick: (location: Location) => void;
}

export default function LocationsBody({
  onCardClick,
}: LocationsBodyProps): React.ReactElement {
  const [seg, setSeg] = useState<Segment>("active");

  const active = LOCATIONS.filter((l) => l.active);
  const inactive = LOCATIONS.filter((l) => !l.active);
  const list = seg === "active" ? active : inactive;

  return (
    <>
      {/* Active / Inactive segmented control */}
      <div style={{ display: "flex", gap: 24, marginBottom: 18 }}>
        <RadioOpt
          label={"Active (" + active.length + ")"}
          on={seg === "active"}
          onClick={() => setSeg("active")}
        />
        <RadioOpt
          label={"Inactive (" + inactive.length + ")"}
          on={seg === "inactive"}
          onClick={() => setSeg("inactive")}
        />
      </div>

      {/* Location cards */}
      {list.map((l) => (
        <div
          key={l.id}
          onClick={() => onCardClick(l)}
          style={{
            border: "0.5px solid " + BORDER,
            borderRadius: 10,
            padding: 18,
            background: BG_CARD,
            display: "flex",
            alignItems: "center",
            gap: 16,
            cursor: "pointer",
            marginBottom: 12,
          }}
        >
          <div style={{ flex: 1 }}>
            {l.isPrimary && (
              <div style={{ marginBottom: 8 }}>
                <span style={BADGE_PRIMARY}>PRIMARY</span>
              </div>
            )}
            <div style={{ fontSize: 12.5, color: TEXT_TERTIARY }}>{l.address}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: TEXT_INK, marginTop: 2 }}>
              {l.name}
            </div>
          </div>
          <ChevronRight size={18} style={{ color: TEXT_TERTIARY }} />
        </div>
      ))}

      {/* Empty state */}
      {list.length === 0 && (
        <div style={{ padding: 22, color: TEXT_SECONDARY, fontSize: 14 }}>
          No {seg} work locations.
        </div>
      )}
    </>
  );
}